
import React, { useEffect, useState, useMemo } from "react";
import "../../styles/category.css";
import "../../styles/cartpop.css";
import Loader from "../../components/loader/loader";
import ProductCard from "./Productcard";
import MiniCart from "./Minicart";
import { stringToTitleCase } from "../../utils/helper";
import { LocalStorageUtils } from "../../utils/localstorage.utils.jsx";
import { EVENT_NAME, PRODUCT } from "utils/constants";
import CommonProductCard from "./CommonProductCard";
import debounce from "lodash.debounce";
import AnalyticsService from "services/analytics.service";

export default function ProductListDisplay({
  products,
  displayName,
  isLoading,
  isRepairPage = false,
}) {
  const [cart, setCart] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const storedCart = LocalStorageUtils.getCart();
    setCart(storedCart);
    setIsInitialLoad(false);
  }, []);

  useEffect(() => {
    if (!isInitialLoad) {
      LocalStorageUtils.setCart(cart);
    }
  }, [cart, isInitialLoad]);

  useEffect(() => {
    const interval = setInterval(() => {
      LocalStorageUtils.removeCart();
      setCart({});
    }, 600000);

    return () => clearInterval(interval);
  }, []);

  const clearFromCart = (productId) => {
    setCart((prevCart) => {
      const updatedCart = { ...prevCart };
      delete updatedCart[productId];
      return updatedCart;
    });
  };

  // Filter products based on search query
  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const searchQueryChange = (e) => {
    const searchQueryText = e.target.value;
    setSearchQuery(searchQueryText);
    AnalyticsService.trackEvent(EVENT_NAME.SEARCH_PRODUCT, {
      searchQuery: searchQueryText,
    });
  };

  const debouncedResults = useMemo(() => {
    return debounce(searchQueryChange, 300);
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <div className="category-page">
          <div className="category-header">
            <h1 className="category-title">{stringToTitleCase(displayName)}</h1>
          </div>
          
          <div className="search-container">
            <input
              type="text"
              placeholder="Search for products..."
              onChange={debouncedResults}
              className="search-input"
            />
          </div>
        
          <div className="product-list">
            {filteredProducts.length === 0 ? (
              <div className="no-products-found">
                No products found matching your search
              </div>
            ) : (
              filteredProducts.map((product) =>
                product.type === PRODUCT.TYPE.COMMON_PRODUCT ? (
                  <CommonProductCard
                    key={product.id}
                    commonProduct={product}
                    cart={cart}
                    setCart={setCart}
                    clearFromCart={clearFromCart}
                    isRepairPage={isRepairPage}
                  />
                ) : (
                  <ProductCard
                    key={product.id}
                    product={product}
                    cart={cart}
                    setCart={setCart}
                    clearFromCart={clearFromCart}
                    isRepairPage={isRepairPage}
                  />
                )
              )
            )}
            <div style={{ height: "50vh" }}></div>
          </div>

          {/* Mini Cart Popup */}
          <MiniCart
            cart={cart}
            setCart={setCart}
            clearFromCart={clearFromCart}
            isRepairPage={isRepairPage}
          />
        </div>
      )}
    </>
  );
}